export default function Chargement({ texte = 'Chargement…' }) {
  return (
    <div className="centre">
      <div className="rond" />
      <p className="discret">{texte}</p>
    </div>
  );
}
